export default [
    {
        path: '/admin/academic/candidate-profiles',
        name: 'candidate-profile',
        meta: { requiresAuth: true },
        component: () => import('@/pages/academic/candidate-profile/index.vue')
    },
    {
        path: '/admin/academic/candidate-profiles/create',
        name: 'candidate-profile-create',
        meta: { requiresAuth: true },
        component: () => import('@/pages/academic/candidate-profile/create.vue')
    },
    {
        path: '/admin/academic/candidate-profiles/:id/edit',
        name: 'candidate-profile-edit',
        meta: { requiresAuth: true },
        component: () => import('@/pages/academic/candidate-profile/edit.vue')
    }
]
